import React from 'react';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import axios from "axios";
import auth from '../../../auth/';
import api from '../../../api/';

const Edit = (props) => {
  const getdb = () => {
    axios.get(api.backup.listdb, auth.header())
      .then((response) => {
        window.open(response.data.url, "")
      });
  };

  const getzip = () => {
    axios.get(api.backup.linkzip, auth.header())
      .then((response) => {
        window.open(response.data.url, "")
      });
  };

  return (
    <ParadigmaModal
      navButton={(props.nav ? true : false)}
      nav={props.nav}
      title={"Generación de Backup"}
      buttonTitle={"Editar"}
      buttonIcon={"fa fa-pencil fa-lg"}
      saveButton={false}
      closeButton={true}
      cancelButtonLabel="Cerrar"
      className="ui-modal-dialog"
    >
      <div className="ui-form text-center">
        <div className="ui-row-2">
          <button type="button" className="ui-btn-primary" onClick={getdb} style={{ justifyContent: 'center', width: '100%' }}>
            <i className="fa fa-database" aria-hidden="true"></i>
            Base de Datos
          </button>
          <button type="button" className="ui-btn-primary" onClick={getzip} style={{ justifyContent: 'center', width: '100%' }}>
            <i className="fa fa-file-archive-o" aria-hidden="true"></i>
            Archivos
          </button>
        </div>
      </div>
    </ParadigmaModal>
  );
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Config/Backup/ModalBackup.js